<template>
    <div class="main-bg">
        <backTitleBar></backTitleBar>
        <div class="page-flex bg-fff page" v-show="bgColor == 'bg-fff'">
            <input type="text" v-model="entity.shopName" placeholder="请输入名称" class="input-show" v-show="type == 'name'">
            <input type="text" v-model="entity.deviceSn" placeholder="请输入SN码" class="input-show" v-show="type == 'sn'">
            <div class="click sure-btn" @click="submit">
                确定
            </div>
        </div>
        <div class="page-flex bg-gray" v-show="bgColor == 'bg-gray'">
            <div class="gray-page" >
                <div class="card" v-show="type == 'address'">
                    <div class="card-item bd-bot click" @click="$refs.pickerArea.popupShow = true">
                        <div class="item-name">所在地区</div>
                        <div class="item-value area">{{entity.areaname.split(",").join(" ")}}</div>
                        <div class="item-icon alifont icon-fanhui1"></div>
                    </div>
                    <div class="card-item">
                        <div class="item-name">详细地址</div>
                        <div class="item-value">
                            <textarea rows="3" placeholder="请输入详细地址" v-model="entity.address"></textarea>
                        </div>
                    </div>
                </div>

                <div v-show="type == 'lnglat'">
                    <div class="search-content" style="margin: 0;">
                        <div class="alifont icon-xpsousuo"></div>
                        <input type="text" placeholder="搜索位置" class="content-input" v-model="addr" @keyup.enter="searchByStationName">
                        <div class="search-btn click" @click="searchByStationName">搜索</div>
                    </div>
                    <div class="bg-fff pd-25 mt-30" style="border-radius: .24rem">
                        <div class="allmap" id="allmap" style="width: 100%;height: 6rem;"></div>
                        <div class="lnglat">
                            <span>经度：{{point.lng}}</span>
                            <span style="margin-left: .8rem">纬度：{{point.lat}}</span>
                        </div>
                    </div>
                </div>

                <div class="card" v-show="type == 'deviceVersionId'">
                    <div class="card-item bd-bot click" @click="showPicker = true">
                        <div class="item-name">硬件版本</div>
                        <div class="item-value area">{{entity.deviceVersionName}}</div>
                        <div class="item-icon alifont icon-fanhui1"></div>
                    </div>
                </div>



                <div class="click sure-btn" @click="submit">
                    确定
                </div>
            </div>
        </div>
        <pickerArea ref="pickerArea" @change="handleConfirm"></pickerArea>

        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="columns"
                    value-key="versionName"
                    @confirm="onConfirm"
                    @cancel="onCancel"
            />
        </van-popup>


    </div>
</template>
<script>

    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {saveShopInfo,listShopDeviceVersion} from "@/api/shop"
    import pickerArea from "@/components/picker-area/index"
    export default{
        name:'equipmentSetting-info',
        components: { backTitleBar,pickerArea },
        data(){
            return {
                entity:{},
                type:'',
                addr:'',
                columns:[],
                map: null,
                localSearch: null,
                marker:null,
                placeSearch:null,
                deviceVersion:null,
                point:null,
                popupShow:false,
                showPicker:false,
            }
        },
        computed:{
            'bgColor':function(){
                if(this.type == 'name' || this.type == 'sn') {
                    return 'bg-fff'
                }else{
                    return 'bg-gray'
                }
            },
            'areaValue':function(){
                return this.entity.countyId
            }
        },
        created(){
            this.$store.state.showFooter = false;
            this.entity = JSON.parse(this.$route.query.shop);
            this.point = {
                lng: this.entity.lng,
                lat: this.entity.lat
            }
            this.type = this.$route.query.type;
            if(this.type == 'deviceVersionId'){
                this.getShopDeviceVersion()
            }
        },
        mounted(){
            if(this.type == 'lnglat'){
                this.initMap();
            }

        },
        methods:{
            initMap(){
                this.map = new AMap.Map("allmap",{
                    resizeEnable: true, //是否监控地图容器尺寸变化
                    zoom: 11,    //初始地图级别
                });         // 创建Map实例
                console.log(this.entity);
                this.marker = new AMap.Marker({
                    position: new AMap.LngLat(this.entity.lng,this.entity.lat),
                });
                this.map.add(this.marker)                                 //添加标注
                this.map.setZoomAndCenter(18, [this.entity.lng,this.entity.lat]);     //地图中心点和缩放级别

                AMap.service(['AMap.PlaceSearch'],function(){
                });                                //添加地图关键字搜索服务
                AMap.plugin(['AMap.ToolBar'], () => {
                    let toolbar = new AMap.ToolBar()
                    this.map.addControl(toolbar)
                })                                 //添加地图控件插件

                this.placeSearch = new AMap.PlaceSearch( {
                    city: '全国'
                });

                //添加点击地图事件
                this.map.on('click', this.clickEvent);
            },
            getShopDeviceVersion() {
                let params = {
                    type:'weigh',
                    limit:50,
                    page:1
                }
                listShopDeviceVersion(params).then((res) => {
                    this.columns = res.data.records;

                });
            },
            onConfirm(value, index) {
                this.deviceVersion = this.columns[index];
                this.entity.deviceVersionName = this.deviceVersion.versionName;
                this.entity.deviceVersionId = this.deviceVersion.versionId;
                this.showPicker = false;
            },
            onCancel(){
                this.showPicker = false;
            },

            //地址搜索
            searchByStationName(){
                let _this = this;
                if(!_this.addr){
                    return
                }else{
                    this.placeSearch.search(_this.addr, function(status, result) {
                        if(result.poiList.pois.length != 0 ){
                            let point = result.poiList.pois[0].location;   //获取第一个智能搜索的结果
                            _this.point = point
                            if(_this.marker){
                                _this.map.remove(_this.marker);
                            }
                            _this.marker = new AMap.Marker({
                                position: new AMap.LngLat(point.lng,point.lat),
                            });
                            _this.map.add(_this.marker)                                 //添加标注
                            _this.map.setZoomAndCenter(18, [point.lng,point.lat]);     //地图中心点和缩放级别
                        }
                    })
                }

            },
            //绑定地图点击事件
            clickEvent(e){
                this.point = e.lnglat;
                if(this.marker){
                    this.map.remove(this.marker);
                }
                this.marker = new AMap.Marker({
                    position: new AMap.LngLat(e.lnglat.lng,e.lnglat.lat),
                });
                this.map.add(this.marker)
                this.map.setZoomAndCenter(18, [e.lnglat.lng,e.lnglat.lat]);
            },

            handleConfirm(e){
                this.entity.areaname = e.map(item=>{
                    return item.areaname
                }).join(",")
                this.entity.provinceId = e[0].areacode;
                this.entity.cityId = e[1].areacode;
                this.entity.countyId = e[2].areacode;
                this.handleCancel()
            },
            handleCancel(){
                this.popupShow = false;
            },
            submit(){
                let _this = this;
                let params = {
                    shopId: this.entity.shopId
                };
                switch (this.type) {
                    case 'name':
                        if(!this.entity.shopName){
                            _this.$toast('请输入名称')
                            return
                        }else{
                            params.shopName = this.entity.shopName
                        }
                        break;
                    case 'sn':
                        if(!this.entity.shopName){
                            this.$toast('请输入SN码')
                            return
                        }else{
                            params.deviceSn = this.entity.deviceSn
                        }
                        break;
                    case 'lnglat':
                        params.lng = this.point.lng;
                        params.lat = this.point.lat;
                        break;
                    case 'address':
                        params.address = this.entity.address;
                        params.provinceId = this.entity.provinceId;
                        params.cityId = this.entity.cityId ;
                        params.countyId = this.entity.countyId ;
                        break;

                    case 'deviceVersionId':
                        params.deviceVersionId = this.entity.deviceVersionId;
                        break;
                }
                saveShopInfo(params).then(res=>{
                    if(res.code == 0){
                        this.$toast("修改成功");
                        this.$router.back();
                    }
                })
            }
        },

    }
</script>
<style lang="scss" scoped>
    .page{
        padding-top: .9rem;
    }
    .input-show{
        margin: 0 .5rem;
        width: 6.5rem;
        padding: .12rem .16rem;
        font-size: .32rem;
        line-height: .45rem;
        border: none;
        border-bottom: .01rem solid $main-color;
        color: #252D46;
        background: none;
    }
    .sure-btn{
        margin: 1.2rem auto 0;
        width: 5.6rem;
        height: .94rem;
        text-align: center;
        line-height: .94rem;
        border-radius: .24rem;
        background: $main-color;
        font-size: .36rem;
        color: #fff;
    }
    .gray-page{
        padding: .28rem .25rem;
        height: 100%;
    }
    .card{
        background: #fff;
        border-radius: .24rem;
        overflow: hidden;
        .card-item{
            display: flex;
            padding: .28rem .32rem;
            .item-name{
                width: 1.7rem;
                font-size: .34rem;
                line-height: .48rem;
                color: #252D46;
            }
            .item-icon{
                font-size: .26rem;
                width: .5rem;
                line-height: .48rem;
                text-align: center;
                color: #CCCCCC;
            }
            .item-value{
                flex: 1;
                textarea{
                    width: 100%;
                    border: none;
                    resize: none;
                    font-size: .34rem;
                    color: #666;
                    line-height: .48rem;
                    padding: 0;
                }
                &.area{
                    font-size: .34rem;
                    line-height: .48rem;
                    color: #252D46;
                }
            }
        }
    }
    .lnglat{
        margin-top: .3rem;
        font-size: .3rem;
        color: #252D46;
        line-height: .42rem;
    }

    .search-content{
        margin: .25rem;
        background: #fff;
        border-radius: .24rem;
        padding: .2rem .4rem;
        display: flex;
        align-items: center;
        .alifont{
            font-size: .36rem;
            color: #919BA6;
            margin-right: .1rem;
        }
        .content-input{
            flex: 1;
            border: none;
            font-size: .3rem;
            line-height: .42rem;
            color: #919BA6;
        }
        .search-btn{
            font-size: .3rem;
            line-height: .42rem;
            color: $main-color;
            margin-left: .2rem;
        }
    }
</style>



// WEBPACK FOOTER //
// equipmentSetting-info.vue?32e7a2f0